import PopoverBottomLeftCode from "!!raw-loader!./popover/BottomLeft.tsx";
import PopoverBottomRightCode from "!!raw-loader!./popover/BottomRight.tsx";
import InfoCode from "!!raw-loader!./popover/Info.tsx";
import PopoverOverlapCode from "!!raw-loader!./popover/Overlap.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import PopoverBottomLeft from "./popover/BottomLeft";
import PopoverBottomRight from "./popover/BottomRight";
import Overlap from "./popover/Overlap";
import Info from "./popover/Info";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Popover Bottom Left", PopoverBottomLeftCode, PopoverBottomLeft),
		paneComponent("Popover Bottom Right", PopoverBottomRightCode, PopoverBottomRight),
		paneComponent("Info Popover", InfoCode, Info),
		paneComponent("Popover Overlap", PopoverOverlapCode, Overlap),
	];

	return (
		<Pane
			components={components}
			imports={"import {InfoPopover, Popover} from \"designSystem/index\";"}
			muiApi="popover"
			muiComponent="popover"
			{...props}
		/>
	);
};